import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const mediaUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${process.env.REACT_APP_BACKEND_URL}${url}`;
};

export const telHref = (phone) => {
  if (!phone) return null;
  const digits = phone.split("(")[0].replace(/[^0-9+]/g, "");
  return digits || null;
};

export const CATEGORY_META = {
  settlement: { icon: "Compass", color: "#2E604A" },
  housing: { icon: "House", color: "#C05E4B" },
  legal: { icon: "Gavel", color: "#7A5C3E" },
  health: { icon: "Stethoscope", color: "#C05E4B" },
  education: { icon: "BookOpen", color: "#2E604A" },
  employment: { icon: "Briefcase", color: "#B8892F" },
  welfare: { icon: "HandHeart", color: "#C05E4B" },
  community: { icon: "Users", color: "#2E604A" },
  resources: { icon: "LifeBuoy", color: "#B8892F" },
  disability: { icon: "Accessibility", color: "#2E604A" },
  scholarships: { icon: "GraduationCap", color: "#7A5C3E" },
};
